import {
  invertStrokeColor
} from "./chunk-VI6WTKMV.js";

// src/icons/ArrowCircle.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function ArrowCircle({
  strokeWidth = "2",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 31 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "15", cy: "15", r: "15", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            className: invertStrokeColor,
            d: "M21 18V9M21 9H12M21 9L9.5 20.5",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  ArrowCircle
};
